import "yuki-createjs";

// tslint:disable-next-line:no-var-requires
require("src/assets/css/style.css");

import * as $ from "jquery";
import * as queryString from "query-string";

import Stage = createjs.Stage;
import Utils from "lib/src/utils";

import "lib/src/StageCanvas";

import Keyboard from "src/Keyboard";

import Globals from "lib/src/Globals";

const char = Utils.getParameterByName("character") || "chloe";

const isDemo = !!queryString.parse(location.search).demo;
export { isDemo };

// 30 is enough for mobile devices
const FPS = isDemo ? 60 : 30;

// createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;
createjs.Ticker.timingMode = createjs.Ticker.RAF;
createjs.Ticker.framerate = FPS;

const keyboard = new Keyboard();

declare var window: any;
const $window = $(window);
$window.ready(() => {
  Utils.initAudio();

  Globals.gameId = "keyboard";

  // noinspection JSIgnoredPromiseFromCall
  keyboard.start();
});

// iOS specific: handle interruptions (Siri)
// Normally, after an interruption, the loops will continue to play, but with some delay between each sample.
window.onWebviewInterrupted = () => {
  keyboard.stopAllLoops();
};



// WEBPACK FOOTER //
// ./src/main.ts